import PropTypes from 'prop-types';

import MMDiscoverSomethingNewActive from './MMDiscoverSomethingNewActive';
import MMDiscoverSomethingNewInactive from './MMDiscoverSomethingNewInactive';

function MMDiscoverSomethingNew({ className, isActive, width }) {
    return isActive ? (
        <MMDiscoverSomethingNewActive className={className} width={width} />
    ) : (
        <MMDiscoverSomethingNewInactive className={className} width={width} />
    );
}

export default MMDiscoverSomethingNew;

MMDiscoverSomethingNew.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    width: PropTypes.number,
};

MMDiscoverSomethingNew.defaultProps = {
    className: '',
    isActive: true,
    width: 24,
};
